import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useUpdateAdsSettingsMutation } from "../../redux/adsApi";
import { useTranslation } from "react-i18next";

function EditAdsSettings({ show, onHide, editData }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ 
        id: "", 
        points_per_ads: "", 
        ads_wait_seconds: "", 
        max_ads_per_hour: "", 
        max_ads_per_day: "", 
        status: "active" 
    });
    const [updateAdsSettings, { isLoading }] = useUpdateAdsSettingsMutation();

    useEffect(() => {
        if (editData) {
            setFormData({
                id: editData.id || "",
                points_per_ads: editData.points_per_ads || "",
                ads_wait_seconds: editData.ads_wait_seconds || "",
                max_ads_per_hour: editData.max_ads_per_hour || "",
                max_ads_per_day: editData.max_ads_per_day || "",
                status: editData.status || "active",
            });
        }
    }, [editData]);

    const handleSave = async () => {
        if (!formData.points_per_ads || !formData.ads_wait_seconds || !formData.max_ads_per_hour || !formData.max_ads_per_day) {
            toast.error(t('fill_required_fields') || "All fields are required!");
            return;
        }

        const submitData = {
            id: formData.id,
            points_per_ads: formData.points_per_ads,
            ads_wait_seconds: formData.ads_wait_seconds,
            max_ads_per_hour: formData.max_ads_per_hour,
            max_ads_per_day: formData.max_ads_per_day,
            status: formData.status
        };

        try {
            const response = await updateAdsSettings(submitData).unwrap();
            if (response.status) {
                toast.success(response.message || "Ads Settings updated successfully!");
                onHide();
            } else {
                toast.error(response.message || "Failed to update ads settings");
            }
        } catch (error) {
            toast.error(error?.data?.message || "Error updating ads settings");
            console.error("Error updating ads settings:", error);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('edit_admob_setting') || 'Edit AdMob Setting'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('points_per_ads') || 'Points Per Ads'}</Form.Label>
                        <Form.Control
                            type="number"
                            value={formData.points_per_ads}
                            onChange={(e) => setFormData({ ...formData, points_per_ads: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('ads_wait_seconds') || 'Ads Wait Seconds'}</Form.Label>
                        <Form.Control
                            type="number"
                            value={formData.ads_wait_seconds}
                            onChange={(e) => setFormData({ ...formData, ads_wait_seconds: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('max_ads_per_hour') || 'Max Ads Per Hour'}</Form.Label>
                        <Form.Control
                            type="number"
                            value={formData.max_ads_per_hour}
                            onChange={(e) => setFormData({ ...formData, max_ads_per_hour: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('max_ads_per_day') || 'Max Ads Per Day'}</Form.Label>
                        <Form.Control
                            type="number"
                            value={formData.max_ads_per_day}
                            onChange={(e) => setFormData({ ...formData, max_ads_per_day: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('status') || 'Status'}</Form.Label>
                        <Form.Select
                            value={formData.status}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        >
                            <option value="active">{t('active') || 'Active'}</option>
                            <option value="inactive">{t('inactive') || 'Inactive'}</option>
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close') || 'Close'}
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={isLoading}>
                    {t('save') || 'Save'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditAdsSettings;
